import Vue from 'vue';
import Vuex from 'vuex';

import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
});

export default new Vuex.Store({
    plugins: [vuexLocal.plugin],
    state: {
        creds: { username: '', password: '' },
        authed: false,
        miniVariant: false,
    },
    mutations: {
        UPDATE_CREDS: (state, creds) => {
            state.creds = creds;
        },
        TOGGLE_AUTH: (state) => {
            state.authed = !state.authed;
        },
        TOGGLE_MINI_VARIANT: (state) => {
            state.miniVariant = !state.miniVariant;
        },
    },
    getters: {
        creds: state => state.creds,
        authed: state => state.authed,
        auth: state => ({ username: state.creds.username, password: state.creds.password }),
        miniVariant: state => state.miniVariant,
    },
    actions: {

    },
});
